import { getRequiredFields } from 'helpers/getRequiredFields';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { FormFieldsConfig } from 'components/DocumentForm';

export const useSchema = (formFields?: FormFieldsConfig[]) => {
  const { t } = useTranslation();

  const requiredFields = formFields ? getRequiredFields(formFields, t) : {};

  return yup.object(requiredFields);
};
